import { render, staticRenderFns } from "./TConcept.vue?vue&type=template&id=1ec83058&scoped=true&"
import script from "./TConcept.vue?vue&type=script&lang=js&"
export * from "./TConcept.vue?vue&type=script&lang=js&"
import style0 from "./TConcept.vue?vue&type=style&index=0&id=1ec83058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec83058",
  null
  
)

export default component.exports